import React from "react";
import { IMatches } from "../types/ITimeline";
import { MatchDetailContainer } from "../styled-components/Drawer.Styles";
import LabelNumber from "../styled-components/LabelNumber";
import noImageClub from "../assets/icons/noImageClub.svg";

interface MatchDetailProps {
  match: IMatches;
  isSelected: boolean;
  onMatchSelect: (matchId: number) => void;
}

const MatchDetail: React.FC<MatchDetailProps> = ({ match, isSelected, onMatchSelect }) => {
  return (
    <MatchDetailContainer isSelected={isSelected} onClick={() => onMatchSelect(match.matchId)} className="match-detail">
      <LabelNumber className="descriptive-large-text">{match.matchLabel}</LabelNumber>
      <img src={match.teamLogoURL ? match.teamLogoURL : noImageClub} alt="Match image" className="team-logoURL" />
      <LabelNumber className="descriptive-large-text">{match.dayOfWeek}</LabelNumber>
    </MatchDetailContainer>
  );
};

export default MatchDetail;
